import colorPicker from "./colorPicker.vue"
import imageUploader from "./imageUploader.vue"
import TextInput from "./TextInput.vue"
import marginPadding from "./marginPadding.vue"
import Border from "./Border.vue"
import selectItem from "./selectItem.vue"
import InputNumber from "./InputNumber.vue"
import ToggleInput from "./ToggleInput.vue"
import ListItems from "./ListItems.vue"
import Font from "./Font.vue"
import ClickAction from "./ClickAction.vue"
import TextAlign from "./TextAlign.vue"
import FontStyling from "./FontStyling.vue"
import InputType from "./InputType.vue"
import StepToggler from "./StepToggler.vue"
import ProductListSettings from "./ProductListSettings.vue"
import VideoUrlInput from "./VideoUrlInput.vue"
import InfoMessage from "./InfoMessage.vue"
import PopupOpenBtn from "./PopupOpenBtn.vue"
import FontPanel from "./FontPanel.vue"
import SocialNetworks from "./SocialNetworks.vue"
import responsiveToggle from "./responsiveToggle.vue"
import MultiSelectItem from "./MultiSelectItem.vue"
import ShadowsInput from "./ShadowsInput.vue"
import Shadow from "./Shadow.vue"
import TransformationInput from "./TransformationInput.vue"
import SizeValue from "./SizeValue"
import ExpireAction from "./ExpireAction"
import hidden from "./hidden"
import FormElementProps from "./FormElementProps"
import SmallNumber from "./SmallNumber"
import CustomCodeButton from "./CustomCodeButton"
import sectionMargin from "./sectionMargin"
import alignment from "./alignment"
import manageProducts from "./manageProducts"
import LazyloadBool from "./LazyloadBool"
import ContainerProps from "./ContainerProps"
import Orientation from './orientation'
import selectProduct from './selectProduct'
import sticky from './Sticky'
import orderSummaryProps from './orderSummaryProps'
import previewImageProps from './PreviewImageProps'
import Toggle from './Toggle'

export default {
    Toggle,
    previewImageProps,
    orderSummaryProps,
    sticky,
    selectProduct,
    Orientation,
    ContainerProps,
    LazyloadBool,
    manageProducts,
    alignment,
    CustomCodeButton,
    sectionMargin,
    SmallNumber,
    FormElementProps,
    hidden,
    ExpireAction,
    colorPicker,
    imageUploader,
    TextInput,
    marginPadding,
    Border,
    selectItem,
    InputNumber,
    ToggleInput,
    ListItems,
    Font,
    ClickAction,
    TextAlign,
    FontStyling,
    InputType,
    StepToggler,
    ProductListSettings,
    VideoUrlInput,
    InfoMessage,
    PopupOpenBtn,
    FontPanel,
    SocialNetworks,
    responsiveToggle,
    MultiSelectItem,
    ShadowsInput,
    Shadow,
    TransformationInput,
    SizeValue,
}
